import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
    {
        q: "How is a 'qualified lead' defined?",
        a: "A lead is considered qualified when the prospect has a stated budget within your target range, a purchase timeline within 6 months, and has confirmed interest in your specific project or micro-market via a live call or WhatsApp response.",
    },
    {
        q: "Which CRMs do you integrate with?",
        a: "We integrate natively with LeadSquared, Zoho CRM, Salesforce, Sell.Do, and Kylas. Leads are pushed via secure webhook within 60 seconds of qualification. Custom integrations are available on Growth and Signature plans.",
    },
    {
        q: "Are you RERA & DPDP-compliant?",
        a: "Yes. All campaigns are RERA-compliant with correct project registration numbers, and lead capture follows India's DPDP Act, 2023 for consent, data minimisation, and right-to-erasure.",
    },
    {
        q: "What's the minimum commitment?",
        a: "A 90-day pilot for the Growth plan, with no long-term lock-in contracts. Commercials are reviewed and can be adjusted at the end of each pilot period.",
    },
    {
        q: "Which cities do you cover?",
        a: "The AI CPL engine is currently active for Delhi NCR, Hyderabad, Bengaluru and Chennai. More Indian cities are being added as we confirm real market data for their micro-markets.",
    },
];

export default function FAQ() {
    const [open, setOpen] = useState(0);
    return (
        <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-16">
                    <div className="flex items-center gap-3 justify-center mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">Frequently Asked</span>
                        <div className="h-px w-10 bg-[#D4AF37]" />
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl">
                        The <span className="italic text-[#D4AF37]">fine</span> print.
                    </h2>
                </div>

                <div className="border-t border-white/10">
                    {faqs.map((f, i) => (
                        <div key={f.q} className="border-b border-white/10">
                            <button
                                data-testid={`faq-${i}`}
                                onClick={() => setOpen(open === i ? -1 : i)}
                                className="w-full text-left py-6 flex items-center justify-between gap-6 hover:text-[#D4AF37] transition-colors"
                            >
                                <span className="font-serif-display text-xl sm:text-2xl">{f.q}</span>
                                <span className="text-[#D4AF37] shrink-0">
                                    {open === i ? <Minus size={20} strokeWidth={1.5} /> : <Plus size={20} strokeWidth={1.5} />}
                                </span>
                            </button>
                            {open === i && (
                                <div className="pb-6 pr-10 text-white/65 leading-relaxed font-body">{f.a}</div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
